import React from 'react';

import { Box } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';
import { cn } from '@opendoor/atoms/utils';

interface LoginSectionProps {
  showLogin: boolean;
  onPress?: () => void;
  // When true, render the link in the inverse (light) foreground for use over a
  // dark/transparent header; otherwise use the primary foreground.
  inverse?: boolean;
}

export const LoginSection: React.FC<LoginSectionProps> = ({ showLogin, onPress, inverse }) => {
  if (!showLogin) return null;

  const handlePress: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    event.preventDefault();
    onPress?.();
  };

  // Keep this as a button action; href="#" resolves against different article
  // routes on the server and client and causes hydration mismatches.
  return (
    <Box
      onClick={handlePress}
      analyticsName="cosmos-sign-in"
      aria-label="Sign in to your account"
      className={cn(
        'hidden h-11 w-max cursor-pointer items-center appearance-none rounded-xl border-0 bg-white/90 px-6 font-medium no-underline shadow-[0_0_0_1px_rgb(88_64_50_/_0.16),inset_0_0_0_1px_rgb(255_255_255_/_0.3),inset_0_-4px_0_0_rgb(88_64_50_/_0.1)] [text-rendering:optimizeLegibility] transition hover:bg-white/90 hover:shadow-[0_0_0_1px_rgb(88_64_50_/_0.3),inset_0_0_0_1px_rgb(255_255_255_/_0.3),inset_0_-4px_0_0_rgb(88_64_50_/_0.05)] focus-visible:outline focus-visible:outline-1 focus-visible:outline-offset-4 focus-visible:outline-[#81a2f2] active:bg-[linear-gradient(rgb(88_64_50_/_0.1),rgb(88_64_50_/_0.1))] active:shadow-[0_0_0_1px_rgb(88_64_50_/_0.3),inset_0_0_0_1px_rgb(255_255_255_/_0.3)] min-[1024px]:inline-flex',
        inverse ? 'text-od-content-inverse-primary!' : 'text-od-content-primary!',
      )}
    >
      <Text as="span" className="text-[16px] font-medium tracking-[-0.8px] text-inherit">
        Sign in
      </Text>
    </Box>
  );
};
